<template>
  <div class="mobile-link bg-f pad-10">
    <div class="justify-between">
      <div class="justify-start">
        <mobile-icon :icon="icon" class="link-icon" />
        <div class="link-text">{{ text }}</div>
        <van-icon name="arrow" color="#666" />
      </div>
      <div class="justify-start">
        <van-icon name="ellipsis" /><mobile-text text="更多" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'mobile-link',
  props: {
    text: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
.mobile-link{
  .link-icon{
    width: 1rem;
    height: 1rem;
  }
  .link-text{
    font-size: .875rem;
    font-weight: bold;
    margin: 0 .3125rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile-link/index.vue